import {BaseEnvironment} from '@shared/consts/base.environment';

export const environment = {
  ...BaseEnvironment,
  CfTurnstileSiteKey: '0x4AAAAAABnsJiVAEwOdMVa1',
  ENDPOINT_DOMAIN: 'https://cloud.fbfast.io',
  ENDPOINT_DOMAIN_API: 'https://cloud.fbfast.io/api',
  ENDPOINT_DOMAIN_FORM: 'https://feedback.fit',
  googleClientId: '770764055564-nn5ctlut1ivergqgroqijl2nsgnj0uue.apps.googleusercontent.com',
  googleMapApiKey: 'AIzaSyAgnYhL28NnJf8VCVgDGSCoYgkFjsQtItc',
  SENTRY_DSN: 'https://6b820c993a10e226f13ef3c939b38728@o4511236377739264.ingest.de.sentry.io/4511236391108688',
};
